import { FC } from 'react';
import { SETVIImage, SText } from '@setvi/shared/components';
import { Container } from './styled';

interface InitRFQProps {
  footer?: JSX.Element;
  onClick?: () => void;
}

const InitRFQ: FC<InitRFQProps> = ({
  footer,
  onClick = () => {}
}: InitRFQProps) => (
  <Container onClick={onClick}>
    <SText
      title="How Auto RFQ Works?"
      weight="bold"
      size="2xl"
      style={{
        marginBottom: 24
      }}
    />

    <SETVIImage
      alt="how auto rfq works"
      src="/images/how-auto-rfq-works.png"
      width="50%"
      style={{
        minWidth: 600
      }}
    />

    {!!footer && footer}
  </Container>
);

export default InitRFQ;
